export const artistCode = {
    primary_artist:'primarycd',
    feature_artist:'featurecd',
    lyricist:'lyricistcd',
    composer:'composercd',
    producer:'producercd',
    actor:'actorcd',
    remixer_artist:'remixercd',
}